import React from 'react'
import '../Project.css';
import Image1 from '../../Gemco-Website-Images/projects/Masdar-Headquarters-Masdar-City-Abu-Dhabi.webp';

const Project_one = () => {

  return (
     <>
    
          <div className='project_1_work' id="workBanner">
    
            <div className="container project_our_work">
    
              <div className="heading">
                <h1>Masdar City Headquarters</h1>
              </div>
    
              <hr></hr>
              <div className='project_section'>
                <div className="project_section_content">
                  <h1 className="project_scope">Scope of Work</h1>
                  <p>The headquarters building of Masdar City — Abu Dhabi's pioneering sustainable urban development and clean energy
                    initiative. Built to exemplary environmental standards incorporating passive cooling, renewable energy and smart building
                    systems. A globally recognised benchmark in sustainable construction.</p>
                  <p>MAIN CONTRACTOR : -</p>
                  <p>MEP CONTRACTOR : JLW</p>
                  <p>GEMCO SCOPE OF WORKS : CHW and electrical works</p>
                  {/* <h2 className="project_years">2014 – 2022</h2> */}
                </div>
                <div className='project_1_card'>
                  <img className="project_one_image" width="500" height="300" src={Image1} alt="Project" />
                </div>
              </div>
            </div>
          </div>
    
        </>

  )
}

export default Project_one